import './App.css';
import {useState } from 'react';


const library_json = '{"0": " ", "255": " ", "3": "#", "5": "\\n", "28": "th", "29": "he", "31": "in", "34": "an", "35": "re", "37": "er", "38": "ou", "40": "to", "42": "ng", "43": "ea", "44": "es", "47": "ar", "48": "is", "50": "ve", "52": "me", "53": "or", "55": "st", "57": "at", "58": "en", "59": "nd", "60": "on", "61": "hi", "62": "se", "63": "as", "64": "ed", "65": "ha", "69": "le", "70": "ow", "72": "ce", "73": "om", "74": "GI", "76": "of", "77": "ro", "78": "ll", "81": "ca", "82": "MA", "83": "te", "85": "ur", "86": "yo", "87": "ti", "90": "ne", "91": "it", "92": "ri", "93": "wa", "94": "ac", "95": "al", "96": "we", "97": "il", "98": "be", "99": "rs", "102": "ge", "104": "li", "105": "..", "122": "/", "123": "+", "128": "0", "129": "1", "130": "2", "131": "3", "132": "4", "133": "5", "134": "6", "135": "7", "136": "8", "137": "9", "138": "A", "139": "B", "140": "C", "141": "D", "142": "E", "143": "F", "144": "G", "145": "H", "146": "I", "147": "J", "148": "K", "149": "L", "150": "M", "151": "N", "152": "O", "153": "P", "154": "Q", "155": "R", "156": "S", "157": "T", "158": "U", "159": "V", "160": "W", "161": "X", "162": "Y", "163": "Z", "164": "a", "165": "b", "166": "c", "167": "d", "168": "e", "169": "f", "170": "g", "171": "h", "172": "i", "173": "j", "174": "k", "175": "l", "176": "m", "177": "n", "178": "o", "179": "p", "180": "q", "181": "r", "182": "s", "183": "t", "184": "u", "185": "v", "186": "w", "187": "x", "188": "y", "189": "z", "190": "\'", "191": ",", "192": ".", "193": ";", "194": "-", "195": "..", "196": "!", "197": "?", "212": "\u2694\ufe0f", "213": "\ud83d\udd28", "214": "\ud83d\udde1\ufe0f", "215": "\ud83e\ude93", "216": "\u269a", "217": "\ud83d\udd87\ufe0f", "218": "\u265e", "219": "\ud83d\udee1\ufe0f", "220": "\ud83e\ude96", "221": "\ud83e\udd4a", "222": "\ud83d\udc8d", "223": "\ud83d\udc55", "224": "%", "225": "@p", "226": "\u20acs", "227": "\u20acp", "228": "\u20acT", "229": "\u20acd", "230": "\u20acf", "231": "\u20aci", "232": "\u20act", "233": "\u20ace", "234": "\u00a7d", "235": "\u00a7s", "236": "\u00a7p", "237": "\u00a7b", "238": "\u00a7P", "239": "\u00a7Z", "240": "\u00a7M", "241": "\u00a7C"}'


const library = JSON.parse(library_json)

function Unit(props) {
    return (
            <div className='Unit' onClick={(e) => {props.callback(e,props.value)}}><span>{props.text}</span></div>
    )
}

function App() {

    const [offset, setOffset] = useState(0)
    const [addd, setArray] = useState([])
    const [magic, setMagic] = useState("")

    const handleClick = (_, v) => {
        setOffset(v)
        makeMagicString(v, addd)
    }

    const makeMagicString = (o, data) => {
        var os = ""
        var index = 0
        while (index < 320) {
            if(index % 40 === 0) {
                os += `||\nWhite: ${Math.floor(index/40)+1}||`
            } else if (index % 20 === 0) {
                os += `|| Black: ${Math.floor(index/40)+1} ||`
            }
            os += library[data[index+o].toString()]
            index++
        }
        os += '||'
        setMagic(os)
    }

    function readFile(evt) {
        var files = evt.target.files;
        var file = files[0];
        var reader = new FileReader();
        var d2 = []

        reader.addEventListener('load', (_) =>  {
            const text_offset = 0x2BD40
            const header = 0x10
            const data = new Uint8Array(reader.result).slice(text_offset + header, text_offset + header + 0x380)
            for (var x in data) {
                d2.push(data[x])
            }

            setArray(d2)
            makeMagicString(offset, d2)

        });
        reader.readAsArrayBuffer(file)
    }


  return (
    <div className="App">
          <span className='instruction'>Step 1: Load the ROM</span>
          <div><input type={'file'} onChange={readFile} /></div>
          <span className='instruction'>Step 2: Click the first letter of the first spell below.</span>
          <div className="Letterlist">
          {addd.map((x,i) => {
              return (<Unit key={i} value={i} callback={handleClick} text={library[x.toString()]} />)
          })}
          </div>
          <span className='instruction'>Step 3: See the magic table below:</span>
          <span>{offset}</span>
          <div>
          <textarea value={magic} rows={9} cols={75} readOnly={true} /> 
          </div>

    </div>
  );
}

export default App;
